import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

import './styles.scss';

const RecaptchaVerification = (props) => {
  // Wyłącz gdy ustawiono lub brak klucza
  const recaptchaDisabled = window.env.RECAPTCHA_DISABLED || !window.env.RECAPTCHA_API_KEY;

  useEffect(() => {
    if (recaptchaDisabled) {
      props.onRecaptchaVerify(true);
    }
  }, []);

  const onRecaptchaChange = (recaptchaValue) => {
    if (recaptchaValue) {
      props.onRecaptchaVerify(true);
    } else {
      props.onRecaptchaVerify(false);
      props.recaptchaRef.current.reset();
    }
  };

  let recaptchaClassNames = 'recaptcha-form-wrapper';

  if (props.className) {
    recaptchaClassNames += ` ${props.className}`;
  }

  return (
    <If condition={!recaptchaDisabled}>
      <div className={recaptchaClassNames}>
        <ReCAPTCHA
          ref={props.recaptchaRef}
          sitekey={window.env.RECAPTCHA_API_KEY}
          onChange={onRecaptchaChange}
          hl="pl"
        />
      </div>
    </If>
  );
};

RecaptchaVerification.propTypes = {
  // Akcja weryfikacji testu (true, false)
  onRecaptchaVerify: PropTypes.func.isRequired,
  // Odniesienie do komponentu
  recaptchaRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape(),
  ]).isRequired,
  // Dodatkowe klasy komponentu
  className: PropTypes.string,
};

RecaptchaVerification.defaultProps = {
  className: '',
};

export default RecaptchaVerification;
